var cookie = {
    set: function (key, val, time) {//设置cookie方法
        var date = new Date(); //获取当前时间
        date.setTime(date.getTime() + time * 24 * 3600 * 1000); //格式化为cookie识别的时间
        var expireDate = "";
        if(time && !isNaN(time)){
            expireDate = ";expires=" + date.toGMTString();
        }
        document.cookie = key + "=" + val + expireDate;  //设置cookie
    },
    get: function (key) {//获取cookie方法
        /*获取cookie参数*/
        var getCookie = document.cookie.replace(/[ ]/g, "");  //获取cookie，并且将获得的cookie格式化，去掉空格字符
        var arrCookie = getCookie.split(";");  //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
        var value = null;  //声明变量tips
        for (var i = 0; i < arrCookie.length; i++) {   //使用for循环查找cookie中的tips变量
            var arr = arrCookie[i].split("=");   //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
            if (key == arr[0]) {  //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
                value = arr[1];   //将cookie的值赋给变量tips
                break;   //终止for循环遍历
            }
        }
        return value;
    },
    clear: function(key){
        this.set(key, '', -1);
    }
};

//返回一个包括URL地址所有参数的对象, 默认不传参则直接取当前页面的url
function queryUrlParams(url) {
    var match,
        pl     = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
        query  = url? url.substring(url.lastIndexOf("?")+1) : window.location.search.substring(1);

    var urlParams = {};
    while (match = search.exec(query))
        urlParams[decode(match[1])] = decode(match[2]);
    return urlParams;
}

function dateFormat(time, fmt) { //author: meizz
    var date = new Date(time);
    var o = {
        "y+":date.getFullYear(),
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
};


//判断IE浏览器版本
function detectIE() {
    var ua = window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
}

//判断是否是IE浏览器，包括Edge浏览器
function IEVersion()
{
  var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
  var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
  var isEdge = userAgent.indexOf("Windows NT 6.1; Trident/7.0;") > -1 && !isIE; //判断是否IE的Edge浏览器
  if(isIE)
  {
    var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    reIE.test(userAgent);
    var fIEVersion = parseFloat(RegExp["$1"]);
    if(fIEVersion == 7)
    { return 7;}
    else if(fIEVersion == 8)
    { return 8;}
    else if(fIEVersion == 9)
    { return 9;}
    else if(fIEVersion == 10)
    { return 10;}
    else if(fIEVersion == 11)
    { return 11;}
    else
    { return 0}//IE版本过低
  }
  else if(isEdge)
  {
    return 12;
  }
  else
  {
    return "-1";//非IE
  }
}

//从localStorage中获取数据
// 若prop为空，则只取健为 key 的storage数据，
// 若prop不为空，则根据 key 取出数据后，再去取该prop的值，如果取不到，返回null
function getLocalStorage(key, prop){
  let item = localStorage.getItem(key);
  if(item){
    item = JSON.parse(item);
    if(prop){
      if(item[prop]){
        item = item[prop];
      }else{
        item = null;
      }
    }
  } else {
    item = null;
  }

  return item;
};


function setLocalStorage(key, data){
  if(key && data){
    localStorage.setItem(key, JSON.stringify(data));
  }
}

//按实际长度截取要求的长度
function cutString (originalStr, limit, withEllipsis){
  let length = lengthCalc(originalStr);
  if(length <= limit){
    return originalStr;
  }

  if(withEllipsis){
    limit = limit -3;
  }

  if(!limit || limit <=0){
    return;
  }

  let newStr = '';
  let len = originalStr.length, charCode = -1;
  for (let i = 0; i < len; i++) {
    charCode = originalStr.charCodeAt(i);
    if (charCode >= 0 && charCode <= 128){
      if(lengthCalc(newStr) + 1 <= limit){
        newStr += String.fromCharCode(charCode);
      }else{
        break;
      }
    }else{
      if(lengthCalc(newStr) + 2 <= limit){
        newStr += String.fromCharCode(charCode);
      }else{
        break;
      }
    }
  }

  if(withEllipsis){
    newStr += "...";
  }

  function lengthCalc(str){
    let len = 0, charCode = -1;
    for (let i = 0; i < str.length; i++) {
      charCode = str.charCodeAt(i);
      if (charCode >= 0 && charCode <= 128){
        len += 1;
      }else{
        len +=2
      }
    }

    return len;
  }
  return newStr;
}

function lengthCalc(str){
  let len = 0, charCode = -1;
  for (let i = 0; i < str.length; i++) {
    charCode = str.charCodeAt(i);
    if (charCode >= 0 && charCode <= 128){
      len += 1;
    }else{
      len +=2
    }
  }
  return len;
}

export default {
  queryUrlParams,
  getLocalStorage,
  setLocalStorage,
  detectIE,
  IEVersion,
  cutString,
  lengthCalc
}



// WEBPACK FOOTER //
// ./src/lib/tools.js